import React from 'react';
import { HeroTypes } from './HeroTypes';
import { ThemeContext } from './hooks/themeContext';
import { VariantContext } from './hooks/variantContext';
import { HeroSection1 } from './variants/HeroSection1';
import { HeroSection2 } from './variants/HeroSection2';
import { HeroSection3 } from './variants/HeroSection3';
import { HeroSection4 } from './variants/HeroSection4';

export const Hero = (heroProps: HeroTypes.ILocationHero) => {
  const { variant = 'hero-section-3', theme = 'light' } = heroProps;
  const renderVariant = {
    'hero-section-1': HeroSection1,
    'hero-section-2': HeroSection2,
    'hero-section-3': HeroSection3,
    'hero-section-4': HeroSection4,
  };
  const VariantToRender = renderVariant[variant];
  return (
    <VariantContext.Provider value={variant}>
      <ThemeContext.Provider value={theme}>
        <div className="heroContainer is-flex is-flex-direction-column">
          <VariantToRender {...heroProps} />
        </div>
      </ThemeContext.Provider>
    </VariantContext.Provider>
  );
};
